<template>
    <div>
      <!--General Top Bar -->
      <!-- <general-top-bar :title="$t('settingsPages.companyWeb')"></general-top-bar> -->
      <!--End General Top Bar -->
      <div class="settings-top-bar sticky-header" ref="optionsTopBar">
        <div class="text-right">
          <p class="d-inline-flex">
            <button type="submit" class="btn btn-success btn-icon mar-rt-10 save"  @click.prevent="saveDetails" :title="$t('general.saveChanges')">
              <img src="/static/img/icons/save.png">
              {{$t('general.save')}}
            </button>
          </p>
        </div>
      </div>
      <form>
        <div class="card mar-to-15">
          <div class="card-content">
            <div class="row">
              <div class="col-md-12">
                <h5 class="">
                  {{$t('settingsWeb.social_media')}}
                </h5>
                <hr/>
              </div>
              <div class="col-md-12">
                <div class="form-group">
                  <label>{{$t('settingsWeb.fbLink')}}</label>
                  <input type="text" name="facebookLink" :placeholder="$t('settingsWeb.fbLink')" v-model="modeldata.facebookLink" class="form-control">
                </div>
              </div>
              <div class="col-md-12">
                <div class="form-group">
                  <label>{{$t('settingsWeb.igLink')}}</label>
                  <input type="text" name="instagramLink" :placeholder="$t('settingsWeb.igLink')" v-model="modeldata.instagramLink" class="form-control">
                </div>
              </div>
              <div class="col-md-12">
                <div class="form-group">
                  <label>{{$t('settingsWeb.trpLink')}}</label>
                  <input type="text" name="tripadvisorLink" :placeholder="$t('settingsWeb.trpLink')" v-model="modeldata.tripadvisorLink" class="form-control">
                </div>
              </div>
              <div class="col-md-12">
                <div class="form-group">
                  <label>{{$t('settingsWeb.twitterLink')}}</label>
                  <input type="text" name="twitter_link" :placeholder="$t('settingsWeb.twitterLink')" v-model="modeldata.twitter_link" class="form-control">
                </div>
              </div>
              <div class="col-md-12">
                <div class="form-group">
                  <label>{{$t('settingsWeb.tiktokLink')}}</label>
                  <input type="text" name="tiktok_link" :placeholder="$t('settingsWeb.tiktokLink')" v-model="modeldata.tiktok_link" class="form-control">
                </div>
              </div>
              <div class="col-md-12">
                <div class="form-group">
                  <label>{{$t('settingsWeb.linkedinLink')}}</label>
                  <input type="text" name="linkedin_link" :placeholder="$t('settingsWeb.linkedinLink')" v-model="modeldata.linkedin_link" class="form-control">
                </div>
              </div>
              <div class="col-md-12">
                <div class="form-group">
                  <label>{{$t('settingsWeb.websitePrezentareLink')}}</label>
                  <input type="text" name="website_prezentare_link" :placeholder="$t('settingsWeb.websitePrezentareLink')" v-model="modeldata.website_prezentare_link" class="form-control">
                </div>
              </div>
              <div class="col-md-12">
                <div class="form-group">
                  <label>{{$t('settingsWeb.whatsapp')}}</label>
                  <p-switch v-model="modeldata.use_whatsapp_chat" name="use_whatsapp_chat" type="success"></p-switch>
                </div>
              </div>
              <div class="col-md-12">
                <h5 class="">
                  {{$t('settingsWeb.link_app')}}
                </h5>
                <hr/>
              </div>
              <div class="col-md-6">
                <div class="form-group">
                  <label>{{$t('settingsWeb.gpLink')}}</label>
                  <input type="text" name="googlePlay" :placeholder="$t('settingsWeb.gpLink')" v-model="modeldata.googlePlay" class="form-control">
                </div>
              </div>
              <div class="col-md-6">
                <div class="form-group">
                  <label>{{$t('settingsWeb.asLink')}}</label>
                  <input type="text" name="appleStore" :placeholder="$t('settingsWeb.asLink')" v-model="modeldata.appleStore" class="form-control">
                </div>
              </div>
              <div class="col-md-12">
                <div class="form-group">
                  <label>{{$t('settingsWeb.site')}}</label>
                  <input type="text" name="website_link" :placeholder="$t('settingsWeb.site')" v-model="modeldata.website_link" class="form-control">
                </div>
              </div>
              <div class="col-md-12">
                <h5 class="">
                  {{$t('settingsWeb.tracking')}}
                </h5>
                <hr/>
              </div>
              <div class="col-md-6">
                <div class="form-group">
                  <label>{{$t('settingsWeb.fbPixel')}}</label>
                  <input type="text" name="facebookPixel" :placeholder="$t('settingsWeb.fbPixel')" v-model="modeldata.facebookPixel" class="form-control">
                </div>
              </div>
              <div class="col-md-6">
                <div class="form-group">
                  <label>{{$t('settingsWeb.fbapid')}}</label>
                  <input type="text" name="facebookAppId" :placeholder="$t('settingsWeb.fbapid')" v-model="modeldata.facebookAppId" class="form-control">
                </div>
              </div>
              <div class="col-md-6">
                <div class="form-group">
                  <label>{{$t('settingsWeb.g4a')}}</label>
                  <input type="text" name="ga4Code" :placeholder="$t('settingsWeb.g4a')" v-model="modeldata.ga4Code" class="form-control">
                </div>
              </div>
              <div class="col-md-12">
                <h5 class="">
                  {{$t('settingsWeb.structure')}}
                </h5>
                <hr/>
              </div>
              <div class="col-md-6">
                <div class="form-group">
                  <label>{{$t('settingsWeb.category_proportion')}}</label>
                  <select name="image_proportion_category" class="form-control"
                                v-model="modeldata.image_proportion_category"
                                >
                    <option value="cover"
                            label="Cover"
                            key="0">
                    </option>
                    <option value="contain"
                            label="Contain"
                            key="1">
                    </option>
                  </select>
                </div>
              </div>
              <div class="col-md-6">
                <div class="form-group">
                  <label>{{$t('settingsWeb.product_proportion')}}</label>
                  <select name="image_proportion_product" class="form-control"
                                v-model="modeldata.image_proportion_product"
                                >
                    <option value="cover"
                            label="Cover"
                            key="0">
                    </option>
                    <option value="contain"
                            label="Contain"
                            key="1">
                    </option>
                  </select>
                </div>
              </div>
              <div class="col-md-6">
                <div class="form-group">
                  <label>{{$t('settingsWeb.display_mode')}}</label>
                  <select name="display_mode" class="form-control"
                                v-model="modeldata.display_mode"
                                >
                    <option value="card"
                            label="Card"
                            key="0">
                    </option>
                    <option value="box"
                            label="Box"
                            key="1">
                    </option>
                  </select>
                </div>
              </div>
              <div class="col-md-6">
                <div class="form-group">
                  <label>{{$t('settingsWeb.display_image_category')}}</label>
                  <select name="display_image_category" class="form-control"
                                v-model="modeldata.display_image_category"
                                >
                    <option value="0"
                            :label="$t('general.no')"
                            key="0">
                    </option>
                    <option value="1"
                            :label="$t('general.yes')"
                            key="1">
                    </option>
                  </select>
                </div>
              </div>
              <div class="col-md-12">
                <h5 class="">
                  {{$t('settingsWeb.design')}}
                </h5>
                <hr/>
              </div>
              <div class="col-md-6">
                <div class="form-group">
                  <label>{{$t('settingsWeb.header_color')}}</label>
                  <input type="text" name="header_color" :placeholder="$t('settingsWeb.header_color')" v-model="modeldata.header_color" class="form-control">
                </div>
              </div>
              <div class="col-md-6">
                <div class="form-group">
                  <label>{{$t('settingsWeb.header_text_color')}}</label>
                  <input type="text" name="header_text_color" :placeholder="$t('settingsWeb.header_text_color')" v-model="modeldata.header_text_color" class="form-control">
                </div>
              </div>
              <div class="col-md-6">
                <div class="form-group">
                  <label>{{$t('settingsWeb.interCol')}}</label>
                  <input type="text" name="interfaceColor" :placeholder="$t('settingsWeb.interCol')" v-model="modeldata.interfaceColor" class="form-control">
                </div>
              </div>
              <div class="col-md-6">
                <div class="form-group">
                  <label>{{$t('settingsWeb.background_color')}}</label>
                  <input type="text" name="background_color" :placeholder="$t('settingsWeb.background_color')" v-model="modeldata.background_color" class="form-control">
                </div>
              </div>
              <div class="col-md-6">
                <div class="form-group">
                  <label>{{$t('settingsWeb.font_product_title')}}</label>
                  <select name="font_product_title" class="form-control"
                                v-model="modeldata.font_product_title"
                                >
                    <option value="Poppins"
                            label="Poppins"
                            key="0">
                    </option>
                    <option value="Source Serif"
                            label="Source Serif"
                            key="1">
                    </option>
                    <option value="QuincyCF"
                            label="QuincyCF"
                            key="2">
                    </option>
                  </select>
                </div>
              </div>
              <div class="col-md-6">
                <div class="form-group">
                  <label>{{$t('settingsWeb.font_product_description')}}</label>
                  <select name="font_product_description" class="form-control"
                                v-model="modeldata.font_product_description"
                                >
                    <option value="Poppins"
                            label="Poppins"
                            key="0">
                    </option>
                    <option value="Source Serif"
                            label="Source Serif"
                            key="1">
                    </option>
                    <option value="QuincyCF"
                            label="QuincyCF"
                            key="2">
                    </option>
                  </select>
                </div>
              </div>
              <div class="col-md-12">
                <h5 class="">
                  Popup imagine
                </h5>
                <hr/>
              </div>
              <template>
                <div class="col-md-12">
                  <el-upload
                    action=""
                    ref="upload"
                    :limit="2"
                    :file-list="[{'url': modeldata.popup_image}]"
                    list-type="picture-card"
                    accept=" .jpg, .jpeg, .png"
                    :on-change="(file,fileList) =>{return handleImgChnage(file,fileList)}"
                    :on-exceed="handleExceed"
                    :on-remove="(file,fileList) =>{return handleRemove(file,fileList)}"
                    :auto-upload="false">
                    <img src="/static/img/icons/icon-plus-primary.png">
                    <div class="el-upload__tip" slot="tip">{{$t('validations.pictureSize')}}</div>
                  </el-upload>
                </div>
              </template>
            </div>
          </div>
        </div>
      </form>
    </div>
</template>
  <script>
    import Vue from 'vue'
    import {Input, Button, Select} from 'element-ui'
    import PSwitch from 'src/components/UIComponents/Switch.vue'
    // import GeneralTopBar from 'src/components/UIComponents/Inputs/generalTopBar.vue'
    import swal from 'sweetalert2'
    import 'sweetalert2/dist/sweetalert2.css'
    import vSelect from 'vue-select'
    Vue.component('v-select', vSelect)
    Vue.use(Button)
    Vue.use(Input)
    Vue.use(Select)
    export default {
      components: {
        // GeneralTopBar,
        [Button.name]: Button,
        [Input.name]: Input,
        [Select.name]: Select,
        PSwitch
      },
      props: {
        modeldata: {}
      },
      methods: {
        saveDetails () {
          var companyID = this.$session.get('selectedCompany')
          var data = {
            'token': this.$session.get('token'),
            'facebookLink': (this.modeldata.facebookLink),
            'instagramLink': (this.modeldata.instagramLink),
            'tripadvisorLink': (this.modeldata.tripadvisorLink),
            'twitter_link': (this.modeldata.twitter_link),
            'tiktok_link': (this.modeldata.tiktok_link),
            'linkedin_link': (this.modeldata.linkedin_link),
            'website_prezentare_link': (this.modeldata.website_prezentare_link),
            'googlePlay': (this.modeldata.googlePlay),
            'appleStore': (this.modeldata.appleStore),
            'facebookPixel': (this.modeldata.facebookPixel),
            'facebookAppId': (this.modeldata.facebookAppId),
            'interfaceColor': (this.modeldata.interfaceColor),
            'header_color': (this.modeldata.header_color),
            'header_text_color': (this.modeldata.header_text_color),
            'ga4Code': (this.modeldata.ga4Code),
            'website_link': (this.modeldata.website_link),
            'image_proportion_category': (this.modeldata.image_proportion_category),
            'image_proportion_product': (this.modeldata.image_proportion_product),
            'display_mode': (this.modeldata.display_mode),
            'font_product_description': (this.modeldata.font_product_description),
            'font_product_title': (this.modeldata.font_product_title),
            'background_color': (this.modeldata.background_color),
            'display_image_category': (this.modeldata.display_image_category),
            'use_whatsapp_chat': (this.modeldata.use_whatsapp_chat),
            'popup_image': (this.modeldata.popup_image)
          }
          var self = this
          this.apiRequest('/settings/website/' + companyID, 'PUT', data, function (response) {
            if (response.status === true) {
              swal({'text': self.$t('settingsWeb.success'), 'type': 'success', 'showConfirmButton': false, 'timer': 2000}).catch(() => {})
            } else {
              swal({'text': self.$t('validations.wentWrong'), 'type': 'error', 'showConfirmButton': false, 'timer': 2000})
            }
          })
        },
        handleImgChnage (file, fileList) {
          const self = this
          // const isJPG = file.type === 'image/jpeg'
          const isOkSize = file.size / 1024 / 1024 < 5
          if (!isOkSize) {
            swal({
              toast: true,
              type: 'warning',
              text: self.$t('general.pictureSizeExceed'),
              position: 'top-end',
              showConfirmButton: false,
              timer: 3000
            })
            self.$refs.upload.clearFiles()
            this.modeldata.popup_image = []
          } else {
            if (fileList.length > 1) {
              this.modeldata.popup_image = fileList.slice(1)
            } else {
              this.modeldata.popup_image = fileList
            }
          }
          this.getBase64(file.raw).then((base64enc) => {
            this.modeldata.popup_image = base64enc
          })
        },
        handleExceed (files, fileList) {
          swal({
            text: this.$t('general.removePhoto'),
            type: 'warning',
            showConfirmButton: true
          })
        },
        handleRemove (file, fileList) {
          this.modeldata.popup_image = ''
        }
      }
    }
  </script>
  
  


// WEBPACK FOOTER //
// src/components/Dashboard/Views/Settings/Tabs/CompanyWeb.vue